module.exports = __webpack_public_path__ + "fonts/SFUIText-LightItalic.367776f3.eot";